"use client";

import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import conversationService from "@/services/conversation.service";

type Props = {
  platformId?: number | null;
  enabled?: boolean;
};

export default function useUnreadConversationsCount({ platformId, enabled = true }: Props) {
  const shouldFetch = enabled && !!platformId;

  const { data, mutate } = useSWR(
    shouldFetch ? [SWR_KEYS.getUnreadConversationsCount, platformId] : null,
    () => conversationService.getUnreadConversationsCount(platformId!),
    { revalidateOnFocus: true, refreshInterval: 60000 }
  );

  return {
    count: data ?? 0,
    mutate,
  };
}
